var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("page-title", { attrs: { title: "Ihre laufenden Supportanfragen" } }),
      _vm._v(" "),
      _c("open-cases-table", {
        attrs: { "case-data": _vm.data },
        on: {
          getAllOpenCases: _vm.getAllOpenCases,
          expandAttendanceOpenCase: _vm.expandAttendanceOpenCase
        }
      }),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { wrap: "" } },
        [
          _c(
            "v-flex",
            {
              staticClass: "right-button-container",
              attrs: { id: "right", xs12: "", md12: "" }
            },
            [
              _c(
                "v-btn",
                {
                  attrs: { id: "form-button" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.goTo()
                    }
                  }
                },
                [_vm._v("Zurück")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }